import { connect } from "react-redux";
import SiteEngineerDetails from "./siteEngineerDetails";
import { bindActionCreators } from "redux";
import { getSiteEngineerDetails } from "services/redux/installation/siteEngineerDetails/action";

const mapStateToProps = (state) => ({
  siteEngineerDetails: state.siteEngineerDetailsReducer.siteEngineerDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    getSiteEngineerDetails,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SiteEngineerDetails);
